import React, { Suspense, useCallback, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { KTSVG } from "../../../../_metronic/helpers";
import clsx from "clsx";
import { toast, Toaster } from "react-hot-toast";
import copy from "copy-to-clipboard";
import LocationOverview from "./Tabs/LocationOverview";
import MachineOverview from "./Tabs/MachineOverview";
import JobsOverview from "./Tabs/JobsOverview";
import TicketsOverview from "./Tabs/TicketsOverview";
import Timeline from "./Tabs/Timeline";
import LocationAddOns from "./Tabs/LocationAddOns";
import { graphql } from "babel-plugin-relay/macro";
import { useLazyLoadQuery } from "react-relay";
import { LocationHistory_getLocationQuery } from "./__generated__/LocationHistory_getLocationQuery.graphql";
import { EditLocation } from "../EditLocation";
import WorkOrdersOverview from "./Tabs/WorkOrdersOverview";
import { getHistory } from "../../../models/_machine";
import LocationRevision from "./Tabs/LocationRevision";
import LocationBreak from "./Tabs/LocationBreak";
import {
  getLocationMachineHistory,
  getSalesPerson,
} from "../../../models/_location";
import LocationCustomerSuccessSpace from "./Tabs/LocationCustomerSuccessSpace";
import Breadcrumb from "../../Common/Breadcrumb";
import LocationMachineHistory from "./Tabs/LocationMachineHistory";
import { IconPickerItem } from "react-fa-icon-picker";
import { UploadPdf } from "../UploadWorkOrderPdf";
import { AddAddOnModal } from "../AddAddOnModal";

export const getLocationById = graphql`
  query LocationHistory_getLocationQuery($id: String!) {
    getLocation(id: $id) {
      id
      uuid
      applicableTax
      contractOwner {
        id
        name
      }
      contractOwnerId
      customerId
      salesLeadId
      salesSupport1Id
      salesSupport2Id
      salesSupport2Persentage
      name
      address
      regionId
      gasSupplierId
      hasSmoodiRouter
      hasWifiExtender
      hasPressurePump
      hasPressureTank
      contactName
      contactPhone
      contactEmail
      latitude
      longitude
      zipCode
      state
      city
      waterPressure
      marketSegmentId
      deploymentManagerId
      businessModelId
      locationTypeId
      targetLaunchDate
      launchDate
      noOfBlenders
      noOfFreezers
      distributorId
      samplingRecommendedTime
      samplingRecommendedDays
      createdAt
      updatedAt
      isActive
      machineCount
      customerSecondContact
      secondContactName
      secondContactPhoneNumber
      secondContactEmail
      secondContactNameRole
      customerMarketingContact
      marketingContactName
      marketingContactPhoneNumber
      marketingContactEmail
      marketingContactNameRole
      customerItContact
      itContactName
      itContactPhoneNumber
      itContactEmail
      itContactNameRole
      customerServiceContact
      serviceContactName
      serviceContactPhoneNumber
      serviceContactEmail
      serviceContactNameRole
      typeOfContactPhoneNumber
      typeOfMarketingContactPhoneNumber
      typeOfSecondContactPhoneNumber
      typeOfItContactPhoneNumber
      typeOfServiceContactPhoneNumber
      storeManagerContact
      storeManagerContactName
      storeManagerContactPhoneNumber
      storeManagerContactEmail
      typeOfStoreManagerContactPhoneNumber
      workOrders {
        id
        deploymentManagerId
        comment
        status
        firstName
        lastName
        date
        installerId
        installerName
      }
      gasSupplier {
        id
        name
      }
      wifiCredentials {
        name
        password
      }
      freezerCredentials {
        apiKey
        serialNumber
      }
      wifiSignalStrength
      businessModel {
        id
        name
      }
      distributor {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
      }
      marketSegment {
        id
        name
      }
      filterProvider {
        id
        title
      }
      deploymentManager {
        id
        firstName
      }
      locationType {
        id
        name
      }
      region {
        id
        name
      }
      customer {
        id
        name
        uuid
        customerCompanyName
        customerContactName
        customerContactPhoneNumber
        customerContactEmail
        customerContactNameRole
        accountType
        distributorId
        customerSecondContact
        customerSecondContactName
        customerSecondContactPhoneNumber
        customerSecondContactEmail
        customerSecondContactNameRole
        isActive
      }
      flavorPrices {
        flavor
        price
      }
      logJobs {
        id
        uuid
        jobType
        locationId
        location {
          id
          name
        }
        dateAndTime
        machineSerialNumber
        machineName
        additionalComments
        createdBy {
          id
          firstName
        }
        createdAt
        status
        closingDateAndTime
      }
      machines {
        id
        uuid
        serialNumber
        name
        deploymentDate
        softwareVersion
        hardwareVersion
        connectionStatus
        createdAt
        updatedAt
        isActive
        remark
        retiredAt
        retiredById
        isRetired

        retiredBy {
          id
          firstName
          lastName
        }
        createdBy {
          id
          firstName
        }
        deployingPerson {
          id
          firstName
        }
        machineStatus {
          id
          name
        }

        tickets {
          id
          uuid
          location {
            name
            id
          }
          machine {
            id
            name
            serialNumber
          }
          media {
            type
            url
          }
          isFilterReplaced
          isSanitizerReplaced
          workStartTime
          ticketType
          serviceType
          comment
          machineServiceOtherInput
          operationOtherInput
          issueReportedOtherInput
          diagnosisOtherInput
          operations {
            id
            name
          }
          machineServicesDone {
            id
            name
          }
          machineServices {
            id
            name
          }
          operationsDone {
            id
            name
          }
          issuesReported {
            id
            name
          }
          diagnosisDone {
            id
            name
          }
          boardId
          board {
            id
            title
            versionNo
          }
          blenderId
          blender {
            id
            title
            versionNo
          }
          ticketType
          serviceType
          comment
          priority
          ticketSource {
            id
            name
          }
          createdBy {
            id
            firstName
          }
          reportedAt
          closingDateAndTime
          assignTo {
            id
            firstName
          }
          status
        }
      }
      businessHours {
        id
        locationId
        dayOfWeek
        openTime
        closeTime
        isOpen
        createdAt
        updatedAt
      }
      servicePlanId
      servicePlan {
        id
        name
        indicater
        createdAt
      }
    }
  }
`;

export const LocationHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const splittedRoute = location.pathname.split("/").reverse()[0];
  if (!splittedRoute) {
    navigate("/locations/list");
  }
  const [machines, setMachines] = React.useState<any>({});
  const [workOrders, setWorkOrders] = React.useState<any>({});
  const [customers, setCustomers] = React.useState<any>({});
  const [locations, setLocations] = React.useState<any>({});
  const [logJobs, setLogJobs] = React.useState<any>([]);
  const [tickets, setTickets] = React.useState<any>([]);
  const [tab, setTab] = React.useState("Overview");
  const [locationEditModal, setLocationEditModal] = React.useState(false);
  const [refreshedQueryOptions, setRefreshedQueryOptions] =
    React.useState<any>(null);
  const [locationHistory, setLocationHistory] = React.useState<any>({});
  const [locationMachineHistory, setLocationMachineHistory] =
    React.useState<any>({});
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(50);
  const [salesInfo, setSalesInfo] = React.useState<any>({});
  const [isHovered, setIsHovered] = useState(false);
  const [uploadPdfModal, setUploadPdfModal] = React.useState(false);
  const [addonEnrollModal, setAddonEnrollModal] = React.useState(false);
  const [addonRefreshTrigger, setAddonRefreshTrigger] = React.useState(0);

  const hoverColor = isHovered ? "#70c057" : "#ffc700";

  const locationRecord = useLazyLoadQuery<LocationHistory_getLocationQuery>(
    getLocationById,
    {
      id: splittedRoute ?? "",
    },
    refreshedQueryOptions ?? {},
  );
  const result: any = locationRecord?.getLocation ?? [];

  const currentLocationId = result.id;
  localStorage.setItem("currentLocationId", currentLocationId);
  const fetchData = async () => {
    const salesInfo = await getSalesPerson(true);
    setSalesInfo(salesInfo);
    if (result == null) {
      navigate("/locations/list");
    } else {
      setLocations(result);
      const customer = result.customer ?? {};
      setCustomers(customer);
      const totalJobs = result.logJobs ?? [];
      setLogJobs(totalJobs);
      const totalMachines = result.machines ?? [];
      setMachines(totalMachines);
      const totalWorkOrders = result.workOrders ?? [];
      setWorkOrders(totalWorkOrders);
      let allTickets: any = [];

      for (const machine of totalMachines) {
        const ticketsRecord = machine.tickets ?? [];
        allTickets = [...allTickets, ...ticketsRecord];
      }
      setTickets(allTickets);
      const locationMachineHistory = await getLocationMachineHistory(
        result.id,
        { page, per_page: perPage },
      );
      setLocationMachineHistory(locationMachineHistory);
    }
  };

  const refresh = useCallback(() => {
    setRefreshedQueryOptions((prev: any) => ({
      fetchKey: (prev?.fetchKey ?? 0) + 1,
      fetchPolicy: "network-only",
    }));
  }, []);
  const handleLocationClose = () => {
    setLocationEditModal(false);
    refresh();
  };
  const handleUploadPdfClose = () => {
    setUploadPdfModal(false);
    refresh();
  };
  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLocationHistory = async () => {
    const locationHistoryPayload = {
      inputs: { id: currentLocationId, type: "Location" },
      pagination: { page, per_page: perPage },
    };
    const locationHistory = await getHistory(
      locationHistoryPayload.inputs,
      locationHistoryPayload.pagination,
    );
    setLocationHistory(locationHistory);
  };

  React.useEffect(() => {
    fetchLocationHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage]);

  return (
    <Suspense>
      <div>
        <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
            style={{ maxWidth: "100%" }}
          >
            <div className="page-title d-flex flex-column justify-content-center flex-wrap">
              <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
                Location History - {locations.uuid}
              </h1>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
              <Breadcrumb
                links={[
                  { label: "Home", href: "/dashboard", isActive: false },
                  {
                    label: "Locations List",
                    href: "/locations/list",
                    isActive: false,
                  },
                  { label: "Location History", href: "", isActive: true },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="mx-xl-4 mt-9">
          <div className="card">
            <div className="card-header cursor-pointer border-bottom-0 py-4">
              <div className="card-title m-0">
                <h3 className="fw-semibold m-0">
                  Location Details - {result.uuid}
                </h3>
              </div>
              <div className="d-flex gap-2">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary btn px-5 py-3 m-1 dropdown-toggle"
                    type="button"
                    id="locationActionsDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa fa-bars fs-4"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="locationActionsDropdown"
                  >
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => setLocationEditModal(true)}
                      >
                        <i className="fa fa-pencil me-2"></i> Edit Location
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => setUploadPdfModal(true)}
                      >
                        <i className="fa fa-upload me-2"></i> Upload Work Order
                        PDF
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => setAddonEnrollModal(true)}
                      >
                        <i className="fa fa-plus me-2"></i> Add Add on
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {locationEditModal && (
          <EditLocation
            locationEditModal={locationEditModal}
            handleLocationClose={handleLocationClose}
            currentLocationId={currentLocationId}
          />
        )}
        <UploadPdf
          currentLocationId={currentLocationId}
          uploadPdfModal={uploadPdfModal}
          handleUploadPdfClose={handleUploadPdfClose}
        />
        <AddAddOnModal
          showModal={addonEnrollModal}
          onClose={() => setAddonEnrollModal(false)}
          locationId={currentLocationId}
          locationName={result?.name}
          onSuccess={() => {
            setAddonRefreshTrigger((prev) => prev + 1);
            refresh();
          }}
        />
        <div className="card mt-9 mx-xl-4">
          <div className="card-body pt-9 pb-0">
            <div className="d-flex flex-wrap flex-sm-nowrap">
              <div className="me-7 mb-4">
                <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                  <img
                    src="/media/icons/duotune/maps/map008.svg"
                    alt="Smoodi"
                    className="bg-light"
                  />
                </div>
              </div>

              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                  <div className="d-flex flex-column pb-lg-0 pb-7">
                    <div className="d-flex align-items-center mb-2">
                      <div className="text-gray-800 fs-2 fw-bolder me-1">
                        <div
                          className="d-flex align-items-center cursor-pointer"
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        >
                          <IconPickerItem
                            icon={locations?.servicePlan?.indicater}
                            size={20}
                            color={hoverColor}
                          />
                          <span
                            className={`ms-1 ${isHovered ? "text-primary" : ""
                              }`}
                          >
                            {locations.name}
                          </span>
                          <IconPickerItem
                            icon={locations?.servicePlan?.indicater}
                            size={20}
                            color={hoverColor}
                            className="ms-2"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="fw-bold fs-6 mb-3 ms-2 pe-2 mt-2">
                      <div className="d-lg-flex d-md-flex d-block align-items-center text-gray-500 mb-3 mt-3 mt-lg-0 mt-md-0">
                        <i className="fa fa-map-marker me-3 fs-6"></i>
                        Location Name :
                        <div
                          className="ms-3 text-gray-800"
                          onClick={() => {
                            if (locations.name) {
                              copy(`${locations.name}`, {
                                message: toast.success("Text Copied"),
                              });
                            }
                          }}
                        >
                          {locations.name}
                          <i
                            className="fa fa-copy text-gray-500 text-hover-gray-600 ms-2"
                            data-bs-toggle="tooltip"
                            title="Copy to clipboard"
                          ></i>
                        </div>
                      </div>
                      <div className="d-lg-flex d-md-flex d-block align-items-center text-gray-500 mb-3 mt-3 mt-lg-0 mt-md-0">
                        <i className="fa fa-address-card me-3 fs-6"></i>
                        Location Address :
                        <div
                          className="ms-3 text-gray-800"
                          onClick={() => {
                            if (locations.address) {
                              copy(`${locations.address}`, {
                                message: toast.success("Text Copied"),
                              });
                            }
                          }}
                        >
                          {locations.address}
                          <i
                            className="fa fa-copy text-gray-500 text-hover-gray-600 ms-2"
                            data-bs-toggle="tooltip"
                            title="Copy to clipboard"
                          ></i>
                        </div>
                      </div>
                      {locations.updatedBy ? (
                        <div className="d-lg-flex d-md-flex d-block align-items-center text-gray-500 mb-3 mt-3 mt-lg-0 mt-md-0">
                          <i className="fa fa-user me-3 fs-6"></i>
                          Last Updated By :
                          <div className="ms-3 text-gray-800">
                            {locations.updatedBy.firstName}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <div className="text-gray-800 fs-4 fw-bolder text-dark mb-3">
                        Customer History :
                      </div>

                      <div className="ms-3  mb-3 mt-3">
                        <i className="fa fa-user me-3 fs-6"></i>
                        <span className="text-gray-800">Customer Name :</span>
                        <Link
                          to={`/customers/list/history/${customers.id}`}
                          className="fw-bold ms-2 align-items-center text-primary fs-6  mt-lg-0 mt-md-0"
                        >
                          {" "}
                          {locations.contactName} - {customers.uuid}
                        </Link>
                        <i className="fa fa-external-link ms-3"></i>
                      </div>

                      <div className="ms-3 mb-3 mt-3 ">
                        <i className="fa fa-phone me-3 fs-6"></i>
                        <span className="text-gray-800">Contact Phone :</span>
                        <Link
                          to={`/customers/list/history/${customers.id}`}
                          className="fw-bold ms-2 align-items-center text-primary fs-6 mt-lg-0 mt-md-0"
                        >
                          {" "}
                          {locations.contactPhone}
                        </Link>
                        <i
                          className="fa fa-copy text-gray-500 text-hover-gray-600 ms-2"
                          data-bs-toggle="tooltip"
                          title="Copy to clipboard"
                          onClick={() => {
                            if (locations.contactPhone) {
                              copy(`${locations.contactPhone}`, {
                                message: toast.success("Text Copied"),
                              });
                            }
                          }}
                        ></i>
                      </div>
                    </div>

                    <div className="ms-3 text-gray-800 text-hover-primary mb-3 mt-3 ">
                      <i className="fa fa-envelope me-3 fs-6"></i>
                      <span className="text-gray-800">
                        {" "}
                        Contact Email :
                      </span>{" "}
                      <Link
                        to={`/customers/list/history/${customers.id}`}
                        className="fw-bold ms-2  align-items-center  fs-6  mt-lg-0 mt-md-0"
                      >
                        {locations.contactEmail}
                      </Link>
                      <i
                        className="fa fa-copy text-gray-500 text-hover-gray-600 ms-2"
                        data-bs-toggle="tooltip"
                        onClick={() => {
                          if (locations.contactEmail) {
                            copy(`${locations.contactEmail}`, {
                              message: toast.success("Text Copied"),
                            });
                          }
                        }}
                        title="Copy to clipboard"
                      ></i>
                    </div>
                  </div>
                  {locations.latitude !== "" && locations.longitude !== "" && (
                    <div className="d-flex w-200px w-sm-300px flex-column mb-3">
                      <div className="card h-100">
                        <div className="card-body p-0">
                          <div className="responsive-map-container">
                            <iframe
                              allowFullScreen
                              title="location-address"
                              src={`//maps.google.com/maps?q=${locations.latitude},${locations.longitude}&z=15&output=embed`}
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="my-4">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="border border-hover-primary border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div className="d-flex align-items-center">
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr066.svg"
                              className="svg-icon-3 svg-icon-success me-2"
                            />
                            <div className="fs-2 fw-bolder">
                              {machines.length ?? 0}
                            </div>
                          </div>

                          <div className="fw-bold fs-6 text-gray-400">
                            Machines
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="border border-hover-primary border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div className="d-flex align-items-center">
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr066.svg"
                              className="svg-icon-3 svg-icon-success me-2"
                            />
                            <div className="fs-2 fw-bolder">
                              {logJobs.length ?? 0}
                            </div>
                          </div>

                          <div className="fw-bold fs-6 text-gray-400">Jobs</div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-xl-4">
                      <div className="col-12 col-md-6">
                        <div className="border border-hover-primary border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div className="d-flex align-items-center">
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr066.svg"
                              className="svg-icon-3 svg-icon-success me-2"
                            />
                            <div className="fs-2 fw-bolder">
                              {tickets.length ?? 0}
                            </div>
                          </div>

                          <div className="fw-bold fs-6 text-gray-400">
                            Tickets
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-xl-4">
                      <div className="col-12 col-md-6">
                        <div className="border border-hover-primary border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div className="d-flex align-items-center">
                            <KTSVG
                              path="/media/icons/duotune/arrows/arr066.svg"
                              className="svg-icon-3 svg-icon-success me-2"
                            />
                            <div className="fs-2 fw-bolder">
                              {workOrders.length ?? 0}
                            </div>
                          </div>

                          <div className="fw-bold fs-6 text-gray-400">
                            Work Orders
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="overflow-auto">
              <ul
                className="nav nav-stretch nav-line-tabs mt-5 border-transparent flex-nowrap fs-5 fw-bolder"
                role="tablist"
              >
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Overview",
                    })}
                    onClick={() => setTab("Overview")}
                    role="tab"
                  >
                    Overview
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Machine",
                    })}
                    onClick={() => setTab("Machine")}
                    role="tab"
                  >
                    Machines
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "MachineHistory",
                    })}
                    onClick={() => setTab("MachineHistory")}
                    role="tab"
                  >
                    Machine History
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Jobs",
                    })}
                    onClick={() => setTab("Jobs")}
                    role="tab"
                  >
                    Log Jobs
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Tickets",
                    })}
                    onClick={() => setTab("Tickets")}
                    role="tab"
                  >
                    Tickets
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "WorkOrders",
                    })}
                    onClick={() => setTab("WorkOrders")}
                    role="tab"
                  >
                    Work Orders
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Timeline",
                    })}
                    onClick={() => setTab("Timeline")}
                    role="tab"
                  >
                    Timeline
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "AddOns",
                    })}
                    onClick={() => setTab("AddOns")}
                  >
                    Add-ons
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Revisions",
                    })}
                    onClick={() => setTab("Revisions")}
                    role="tab"
                  >
                    Revisions
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "Breaks",
                    })}
                    onClick={() => setTab("Breaks")}
                    role="tab"
                  >
                    Breaks
                  </div>
                </li>
                <li className="nav-item me-4">
                  <div
                    className={clsx(`nav-link cursor-pointer pb-5`, {
                      active: tab === "CustomerSuccessNotes",
                    })}
                    onClick={() => setTab("CustomerSuccessNotes")}
                    role="tab"
                  >
                    Notes
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="tab-content pt-3">
          <div className={clsx("tab-pane", { active: tab === "Overview" })}>
            <LocationOverview locations={locations} salesPerson={salesInfo} />
          </div>
          <div className={clsx("tab-pane", { active: tab === "Machine" })}>
            <MachineOverview machines={machines} />
          </div>
          <div
            className={clsx("tab-pane", { active: tab === "MachineHistory" })}
          >
            <LocationMachineHistory
              locationMachineHistory={locationMachineHistory}
              page={page}
              setPage={setPage}
              perPage={perPage}
            />
          </div>
          <div className={clsx("tab-pane", { active: tab === "Jobs" })}>
            <JobsOverview logJobs={logJobs} />
          </div>
          <div className={clsx("tab-pane", { active: tab === "Tickets" })}>
            <TicketsOverview tickets={tickets} />
          </div>
          <div className={clsx("tab-pane", { active: tab === "WorkOrders" })}>
            <WorkOrdersOverview workOrders={workOrders} locations={locations} />
          </div>
          <div className={clsx("tab-pane", { active: tab === "Timeline" })}>
            <Timeline machines={machines} logJobs={logJobs} tickets={tickets} />
          </div>
          <div className={clsx("tab-pane", { active: tab === "AddOns" })}>
            <LocationAddOns
              locationId={currentLocationId}
              setShowModal={setAddonEnrollModal}
              refreshTrigger={addonRefreshTrigger}
              onRefresh={refresh}
            />
          </div>
          <div className={clsx("tab-pane", { active: tab === "Revisions" })}>
            <LocationRevision
              locationHistory={locationHistory}
              page={page}
              setPage={setPage}
              perPage={perPage}
            />
          </div>
          <div className={clsx("tab-pane", { active: tab === "Breaks" })}>
            <LocationBreak locations={locations} />
          </div>
          <div
            className={clsx("tab-pane", {
              active: tab === "CustomerSuccessNotes",
            })}
          >
            <LocationCustomerSuccessSpace locations={locations} />
          </div>
        </div>
      </div>
      <Toaster
        position="bottom-left"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 3000,
        }}
      />
    </Suspense>
  );
};
